<template>
  <div class="container">
    <app-header title="我的历史求购" />
    <div class="main">

      <!--表格-->
      <div class="item" v-for="(item,index) in list">
        <div class="title">{{item.createTime}}</div>
        <div class="table_box_big" v-if="item.fileType==2">
          <div class="table_box">
            <table class="table" border="0" width="100%"  style="table-layout:fixed">
              <!-- 表头 -->
              <thead>
              <tr>
                <th>*产品型号</th>
                <th>产品名称</th>
                <th>产品封装</th>
                <th>品牌要求</th>
                <th>接受价格</th>
                <th>产品数量</th>
                <th>备注</th>
              </tr>
              </thead>
            </table>
            <div class="table_tbody_box">
              <table class="table"  border="0" width="100%" cellspacing="10" style="table-layout:fixed">
                <tbody>
                <tr v-for="(item1,index) in item.purchaseItems" :key="index">
                  <td><page-input v-model="item1.model" class="input"/></td>
                  <td><page-input v-model="item1.name" class="input"/></td>
                  <td><page-input v-model="item1.packages" class="input"/></td>
                  <td><page-input v-model="item1.brand" class="input"/></td>
                  <td><page-input v-model="item1.price" class="input"/></td>
                  <td><page-input v-model="item1.number" class="input"/></td>
                  <td><page-input v-model="item1.remark" class="input"/></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!--图片-->
        <div class="upimg" v-if="item.fileType==1">
          <van-uploader
            multiple
            :deletable='false'
            :max-count='item.file | filterCount'
            :file-list="item.file | filterPic"
          />
        </div>
        <!--文件-->
        <div class="upimg" v-if="item.fileType==0">
          <van-uploader
            multiple
            :deletable='false'
            :max-count='item.file | filterCount'
            :file-list="item.file | filterPic"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Uploader } from 'vant'
  import { uploadimage } from '@/api/file.js'
  import { getShopPurchaseList } from '@/api/purchase/index.js'
  Vue.use(Uploader)
  export default {
    data() {
      return {
        list: [],
        fileList: [],
        fileList2: [],
      }
    },
    filters: {
      filterCount(val){
        let pic = [];
        if (!val){
          return 0;
        }
        pic = JSON.parse(val);
        console.log(pic)
        return pic.length;
      },
      filterPic(val){
        let pic = [];
        if (!val){
          return pic;
        }
        // JSON.parse(val).forEach(item=>{
        //   pic.push(item.url);
        // })
        pic = JSON.parse(val);
        console.log(pic)
        return pic;
      }
    },
    created() {
      this._getShopPurchaseList()
    },
    methods: {
      _getShopPurchaseList() {
        var user = localStorage.getItem("userInfo")
        user = JSON.parse(user)
        const params = {
          type: this.$route.query.activeTag,
          uid: user.id
        }
        getShopPurchaseList(params).then((res) => {
          if (res.success) {
            this.list = res.data
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .title{
    height: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    padding: 0 12px;
  }
  .main{
    padding: 0 12px;
    .table_box_big{overflow-x: scroll;overflow-y: hidden;position: relative;height: 350px;}
    .table_box{overflow: hidden;position: absolute;}
    .table_tbody_box{height: 300px;overflow: scroll;}
    table thead tr th{
      width:100px;
      height:30px;
      text-align: center;
      word-break: keep-all;
      padding: 2px 10px;
      font-size:13px;
      font-weight:400;
      color:rgba(102,102,102,1);

    }
    table tbody tr td{
      width:100px;
      height:30px;
      line-height: 30px;
      border: 1px solid #eeeeee;
      text-align: center;
      word-break: keep-all;
      padding: 2px 10px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      font-size:13px;
      font-weight:400;
      color:rgba(102,102,102,1);
      .input{
        width:80px;
        border: none;
      }
    }
  }
  .upimg{
    box-sizing: border-box;
    padding: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/buy/history.vue